import { CallRecordKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectCallRecordIsPersonalRecording,
    selectCallRecordRecordedCallKey,
} from 'flow/selectors/call-records-selectors';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

interface Props {
    callRecordKey: CallRecordKey;
}

const MenuItemDeleteRecording = ({ callRecordKey }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const isPersonalRecording = useAppSelector((state) =>
        selectCallRecordIsPersonalRecording(state, callRecordKey),
    );
    const recordedCallKey = useAppSelector((state) =>
        selectCallRecordRecordedCallKey(state, callRecordKey),
    );

    if (!isPersonalRecording) return null;

    const onClickDelete = () => {
        openModal('deleteRecording', {
            recordedCallKey,
            callRecordKey,
        });
    };

    return (
        <MenuItem onClick={onClickDelete}>
            <div className="text-red flex items-center gap-x-2">
                <Icon iconKey="delete" />
                {i18next.t('call.recording.delete')}
            </div>
        </MenuItem>
    );
};

export default MenuItemDeleteRecording;
